import { useDispatch } from "react-redux";
import usersService from "../../services/users.service"
import { timeSessionDifference } from "../auth/timeSessionDifference";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useCallback, useEffect, useRef, useState } from "react";
import { useAuthInfo } from "../../utils/authUtils";
import { sesionExpired } from "../auth/sesionExpired";
import { actionErrorConnection } from "../component/actionErrorConnection";

const useGetCustomers = () => {
    const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
    const sessionDifference = timeSessionDifference();
    const {noCustomer: an8Logged} = useAuthInfo()
    const dispatch = useDispatch();
    const history = useHistory();
    const hasFetched = useRef(false); 
    const [customers, setCustomers] = useState({
        isLoading: true,
        isDisabled: true,
        data: []
    })
    /**
     * Recupera la lista de clientes
     * @param {string} an8 - identificador del cliente
     * @author alSanchez - ETE
     * @version 1.0.0 - Enero 2024
     */

    const getCustomers = useCallback(() => {
        if (hasFetched.current) return; 
        hasFetched.current = true;
        usersService.getCustomerAssociatesByAN8(an8Logged)
          .then((response) => {
            setCustomers({
              isLoading: false,
              isDisabled: false,
              data: response
            });
          })
          .catch((error) => {
            console.error(error);
            setCustomers({
              isLoading: false,
              isDisabled: false,
              data: []
            });

            if (sessionDifference > Number(tokenExpired)) {
              sesionExpired(dispatch, history);
            } else {
              actionErrorConnection(error, 'Error al recuperar clientes.');
            }
          });
          // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [an8Logged]);

    useEffect(() => {
        getCustomers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { customers, getCustomers };
};
export default useGetCustomers;